import Accordion from 'react-bootstrap/Accordion';
import { Condition } from "./conditions/Condition";
import { Allergies } from "./allergies/Allergies";
import { Medications } from './medications/Medications';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { setPageTitle } from '../../store/slices/pageTitleSlice';

export const History = () => {

    const { patientId } = useParams<{ patientId: string }>();
    const dispatch = useDispatch();

     useEffect( () => {
        dispatch(setPageTitle('History: Patient Profile | Spire360'));
      }, []);
    
    return(
        <div className="tabs__content">
            <Accordion defaultActiveKey="0">
                <Accordion.Item className="toggle-left" eventKey="0">
                    <Accordion.Header>
                        Medications
                    </Accordion.Header>
                    <Accordion.Body>
                        {
                            <Medications patientId={patientId!}/>
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

            <Accordion defaultActiveKey="1">
                <Accordion.Item className="toggle-left mt-4" eventKey="1">
                    <Accordion.Header>
                        Conditions
                    </Accordion.Header>
                    <Accordion.Body>
                        {
                            <Condition patientId={patientId!}/>
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Accordion defaultActiveKey="2">
                <Accordion.Item className="toggle-left mt-4" eventKey="2">
                    <Accordion.Header>
                        Allergies
                    </Accordion.Header>
                    <Accordion.Body>
                        {
                            <Allergies patientId={patientId!}/>
                        }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            
        </div>
    )
}